import moment from 'moment';
import Cookie from 'js-cookie';

const twelveMonths = moment.duration(12, 'months').asSeconds();
const GDPR_COOKIE_KEY = 'hasAcknowledgedGdprUsSite';

export default class GDPRBanner {
  constructor() {
    this.gdprAcknowledgementFlash = this.getGdprAcknowledgementFlash();
    this.gdprAcknowledgementBtn = document.getElementById(
      'js-gdpr-site-us-acknowledgement-btn'
    );
  }

  getGdprAcknowledgementFlash() {
    const elements = document.getElementsByClassName('flash gdpr');
    return elements && elements[0];
  }

  showGdprBannerIfNecessary(geo) {
    if (geo && geo.is_eu) {
      // If the cookie is set, then skip it.
      const hasAcknowledgedGdpr = Cookie.get(GDPR_COOKIE_KEY);
      if (hasAcknowledgedGdpr && hasAcknowledgedGdpr === 'true') {
        return;
      }

      this.showGdprAcknowledgementFlash();
    }
  }

  showGdprAcknowledgementFlash() {
    if (this.gdprAcknowledgementFlash) {
      this.gdprAcknowledgementFlash.style.display = 'block';
      if (this.gdprAcknowledgementBtn) {
        this.gdprAcknowledgementBtn.addEventListener('click', e => {
          e && e.preventDefault();
          this.hideGdprAcknowledgementFlash();
        });
      }
    }
  }

  hideGdprAcknowledgementFlash() {
    if (this.gdprAcknowledgementFlash) {
      Cookie.set(GDPR_COOKIE_KEY, true, { expires: twelveMonths });
      this.gdprAcknowledgementFlash.remove();
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/application/gdpr-banner.js